<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title1"><a id="page_1"></a>LOCKHEED</h1>
<h1 class="title">TRISTAR</h1>
<p class="sub-title">THE MOST TECHNOLOGICALLY ADVANCED COMMERCIAL JET OF ITS TIME</p>
<p class="author">GRAHAM M. SIMONS</p>
<div class="img_containert">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?60bd071e